var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"active-system-check",attrs:{"data-name":_vm.dataName}},[_c(_vm.activeStep.component,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }